import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import { Spinner } from 'react-bootstrap'

import AppLayout from './layout/AppLayout.jsx'
import Logout from './pages/Logout.jsx'
import Home from './pages/Home.jsx'
import Campaigns from './pages/Campaigns.jsx'
import Contacts from './pages/Contacts.jsx'
import ProofTemplates from './pages/ProofTemplates.jsx'
import PrintCollaterals from './pages/PrintCollaterals.jsx'
import Dashboard from './pages/Dashboard.jsx'
import Users from './pages/Users.jsx'
import Plans from './pages/Plans.jsx'
import UserProfile from './pages/UserProfile.jsx'
import AddOns from './pages/AddOns.jsx'
import Subscription from './pages/Subscription.jsx'
import UsageTracker from './pages/UsageTracker.jsx'
import Payments from './pages/Payments.jsx'
import Subscriptions from './pages/Subscriptions.jsx'
import ActivityLogs from './pages/ActivityLogs.jsx'
import MyActivity from './pages/MyActivity.jsx'

function App() {
  const auth = useAuth()
  const [authError, setAuthError] = useState(null)
  const [userDetails, setUserDetails] = useState({
    userRole: null,
  })

  const BEARER = auth?.user?.access_token
    ? `Bearer ${auth?.user?.access_token}`
    : null
  console.log('AUTH', auth)
  console.log('AUTH USER', auth.user)
  console.log('BEARER', BEARER)

  useEffect(() => {
    if (
      !auth.isLoading &&
      !auth.isAuthenticated &&
      location.pathname !== '/logout'
    ) {
      auth.signinRedirect()
    }
  }, [auth.isLoading, auth.isAuthenticated, location.pathname, auth])

  useEffect(() => {
    setAuthError(null)
    if (auth.user?.profile) {
      setUserDetails({
        userRole: auth.user.profile['custom:role'],
      })
    }
  }, [auth.user])

  if (auth.isLoading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" role="status" />
      </div>
    )
  }
  if (authError) {
    return (
      <Alert variant="danger" style={{ width: '80%', margin: '4%' }}>
        {authError}
      </Alert>
    )
  }
  if (auth.error) {
    return (
      <div className="loading-container">
        Encountering error... {auth.error.message}
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route
          path="/"
          element={
            auth.isAuthenticated ? (
              <AppLayout userRole={userDetails.userRole} bearerToken={BEARER} />
            ) : null
          }
        >
          <Route index element={<Home />} />
          <Route
            path="users"
            element={
              <Users userRole={userDetails.userRole} bearerToken={BEARER} />
            }
          /> 
          <Route
            path="plans"
            element={
              <Plans userRole={userDetails.userRole} bearerToken={BEARER} />
            }
          />
          <Route 
            path='subscriptions'
            element={
              <Subscriptions userRole={userDetails.userRole} bearerToken={BEARER} />
            }
          />
           <Route
            path='activity_logs'
            element={
              <ActivityLogs userRole={userDetails.userRole} bearerToken={BEARER}/>
          }
          />
          <Route
            path="campaigns"
            element={
              <Campaigns userRole={userDetails.userRole} bearerToken={BEARER} />
            }
          />
          <Route
            path="contacts"
            element={
              <Contacts userRole={userDetails.userRole} bearerToken={BEARER} />
            }
          />
          <Route
            path="dashboard"
            element={
              <Dashboard userRole={userDetails.userRole} bearerToken={BEARER} />
            }
          />
          <Route
            path="proof_templates"
            element={
              <ProofTemplates
                userRole={userDetails.userRole}
                bearerToken={BEARER}
              />
            }
          />
          <Route
            path="print_collaterals"
            element={
              <PrintCollaterals
                userRole={userDetails.userRole}
                bearerToken={BEARER}
              />
            }
          />
          <Route
            path="user_profile"
            element={
              <UserProfile
                userRole={userDetails.userRole}
                bearerToken={BEARER}
              />
            }
          />
          <Route
            path="my_activity"
            element={
              <MyActivity
                userRole={userDetails.userRole}
                bearerToken={BEARER}
              />
            }
          />
        <Route 
          path = "add_ons"
          element={
            <AddOns
              userRole={userDetails.userRole}
              bearerToken={BEARER}
            />
          }
        />
        <Route 
          path="payments"
          element={
            <Payments
              userRole={userDetails.userRole}
              bearerToken={BEARER}
            />
          }
        />
        <Route 
         path="subscription"
         element={
          <Subscription
            userRole={userDetails.userRole}
            bearerToken={BEARER}
          />
         }
         />
        <Route 
          path="usage_tracker"
          element={
            <UsageTracker
              userRole={userDetails.userRole}
              bearerToken={BEARER}
            />
          }
        />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
